<template>
  <div style="height: 100%">
    <div class="members-pc-body">
      <div class="body">
        <div class="title">{{ members.title }}</div>
        <div class="content">
          <div class="left">
            <div class="group-title">{{ members.title }}</div>
            <div
              class="group-item"
              v-for="item in groups"
              :key="item"
              @click="onChooseGroup(item)"
            >
              <div
                :class="
                  selectedGroup != item ? 'group-normal' : 'group-selected'
                "
              >
                {{ getMoreTitle(item) }}
              </div>
            </div>
          </div>
          <div class="right">
            <div class="staffs" v-if="selectedGroup === 'staffs'">
              <div class="right-title">{{ getMoreTitle("staffs") }}</div>
              <div class="person-list">
                <div
                  v-for="item in members.staffs"
                  :key="item.name"
                  class="person"
                >
                  <img :src="'static/pic/' + item.image" />
                  <div class="name">
                    {{ item.name }}
                    <a v-if="item.detailUrl" :href="item.detailUrl"  target="_blank">{{
                      getMoreText
                    }}</a>
                  </div>
                  <div class="job" v-if="item.title">{{ item.title }}</div>
                  <div class="desc" v-if="item.subTitle">
                    {{ item.subTitle }}
                  </div>
                  <div class="tel" v-if="item.phone">{{ item.phone }}</div>
                  <div class="email" v-if="item.email">{{ item.email }}</div>
                </div>
              </div>
            </div>
            <div class="students" v-if="selectedGroup === 'students'">
              <div class="right-title">{{ getMoreTitle("students") }}</div>
              <div class="person-list">
                <div
                  v-for="item in members.students"
                  :key="item.name"
                  class="person"
                >
                  <img :src="'static/pic/' + item.image" />
                  <div class="name">
                    {{ item.name }}
                    <span>({{ item.title }})</span>
                  </div>
                  <div class="tel" v-if="item.phone">{{ item.phone }}</div>
                  <div class="email" v-if="item.email">{{ item.email }}</div>
                  <div class="school" v-if="item.school">
                    {{ item.school }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="former-member"
              v-if="selectedGroup === 'formerMembers'"
            >
              <div class="right-title">
                {{ getMoreTitle("formerMembers") }}
              </div>
              <div class="person-list">
                <div
                  v-for="item in members.formerMembers"
                  :key="item.name"
                  class="person"
                >
                  <div class="name">
                    {{ item.name }}
                    <span>({{ item.subTitle }})</span>
                  </div>
                  <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="members-mobile-body">
      <div class="header" @click="showMobileMenu()">
        {{ getMoreTitle(selectedGroup) }}
        <i class="el-icon-arrow-down" v-show="!isMobileMenuShow" /><i
          class="el-icon-arrow-up"
          v-show="isMobileMenuShow"
        />
      </div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div
          v-for="item in groups"
          :key="item"
          @click="onChooseGroup(item)"
          class="header-menu-item"
        >
          <div
            :class="selectedGroup != item ? 'group-normal' : 'group-selected'"
          >
            {{ getMoreTitle(item) }}
          </div>
        </div>
      </div>
      <div class="mobile-body">
        <div class="title">{{ members.title }}</div>
        <div class="staffs" v-if="selectedGroup === 'staffs'">
          <div class="title">{{ getMoreTitle("staffs") }}</div>
          <div class="person-list">
            <div v-for="item in members.staffs" :key="item.name" class="person">
              <img :src="'static/pic/' + item.image" />
              <div class="name">
                {{ item.name }}
                <a v-if="item.detailUrl" :href="item.detailUrl" target="_blank">{{
                  getMoreText
                }}</a>
              </div>
              <div class="job" v-if="item.title">{{ item.title }}</div>
              <div class="desc" v-if="item.subTitle">{{ item.subTitle }}</div>
              <div class="tel" v-if="item.phone">{{ item.phone }}</div>
              <div class="email" v-if="item.email">{{ item.email }}</div>
            </div>
          </div>
        </div>
        <div class="students" v-if="selectedGroup === 'students'">
          <div class="title">{{ getMoreTitle("students") }}</div>
          <div class="person-list">
            <div
              v-for="item in members.students"
              :key="item.name"
              class="person"
            >
              <img :src="'static/pic/' + item.image" />
              <div class="name">
                {{ item.name }}
                <span>({{ item.title }})</span>
              </div>
              <div class="tel" v-if="item.phone">{{ item.phone }}</div>
              <div class="email" v-if="item.email">{{ item.email }}</div>
              <div class="school" v-if="item.school">{{ item.school }}</div>
            </div>
          </div>
        </div>
        <div class="former-member" v-if="selectedGroup === 'formerMembers'">
          <div class="title">{{ getMoreTitle("formerMembers") }}</div>
          <div class="person-list">
            <div
              v-for="item in members.formerMembers"
              :key="item.name"
              class="person"
            >
              <div class="name">
                {{ item.name }}
                <span>({{ item.subTitle }})</span>
              </div>
              <div class="desc" v-if="item.desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurLan, isChinese } from "@/util/tools";
export default {
  name: "members-page",
  data() {
    return {
      isMobileMenuShow: false,
      groups: [],
      selectedGroup: "staffs",
      members: {
        title: "小组成员",
        staffs: [
          {
            name: "吴克辉",
            title: "研究员,课题组长",
            subTitle: "杰青、万人计划领军人才",
            phone: "010-82648130(office)\n 010 - 82648025(lab)",
            email: "khwu(at)iphy.ac.cn",
            detailUrl: "http://www.iop.cas.cn/rcjy/jcqn/?id=339",
            image: ""
          }
        ]
      }
    };
  },
  mounted() {
    var self = this;
    getCurLan().then(res => {
      self.members = res.members;
      if (self.members.staffs) {
        // self.groups.push("Staffs");
        self.groups.push("staffs");
      }
      if (self.members.students) {
        // self.groups.push("Students");
        self.groups.push("students");
      }
      if (self.members.formerMembers) {
        // self.groups.push("Former Members");
        self.groups.push("formerMembers");
      }
    });
    // this.members = getCurLan().members; //'Staffs', 'Students', 'Former members'
    // if (this.members.staffs) {
    //   this.groups.push('Staffs')
    // }
    // if (this.members.students) {
    //   this.groups.push('Students')
    // }
    // if (this.members.formerMembers) {
    //   this.groups.push('Former Members')
    // }
  },
  computed: {
    getMoreText: function() {
      if (isChinese()) {
        return "【个人介绍】";
      } else {
        return "【Intro】";
      }
    }
  },
  methods: {
    onChooseGroup(item) {
      this.selectedGroup = item;
      if (this.isMobileMenuShow) {
        this.isMobileMenuShow = false;
      }
    },
    showMobileMenu() {
      this.isMobileMenuShow = !this.isMobileMenuShow;
    },
    getMoreTitle(oriStr) {
      const en_map = {
        staffs: "Staffs",
        students: "Students",
        formerMembers: "Former Members"
      };
      const ch_map = {
        staffs: "研究人员",
        students: "在读学生",
        formerMembers: "曾经组员"
      };
      if (isChinese()) {
        return ch_map[oriStr];
      } else {
        return en_map[oriStr];
      }
    }
  }
};
</script>
<style lang="scss" src="../assets/styles/pc/members-page.scss"></style>
<style lang="scss" src="../assets/styles/mobile/members-page.scss"></style>



// WEBPACK FOOTER //
// src/components/Members.vue